import React from 'react';

import { CompanyCard, SoldToAddressCard } from '../../../../../../components/cards/company';
import { AdditionalAttachmentCard } from '../../../../../../components/cards/financial/AttachmentCard';
import PrivacyPolicyCard from '../../../../../../components/cards/financial/PrivacyPolicyCard';
import {
  CertOfAnalysisContactCard,
  DeliveryInstructionsCard,
  InvoiceDeliveryContactCard,
  OrderConfirmationContactCard,
  PackingListContactCard
} from '../../../../../../components/cards/shipTo';
import CompanyPage from '../../../../../../features/CompanyPage';
import ReviewPage from '../../../../../../features/ReviewPage';
import { CARD_CATEGORIES } from '../../../../../../shared/cardConfig/constants';
import {
  ATTACHMENT_FIELDS,
  COMPANY_FIELDS,
  CONTACT_FIELDS,
  CONTACT_SAME_AS_FIELDS,
  DELIVERY_INSTRUCTIONS_FIELDS,
  SOLD_TO_ADDRESS_FIELDS
} from '../../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../../utils/constants';

// ----------------- Type Definitions -----------------
interface Field {
  key: string;
  required?: boolean;
}

interface Card {
  key: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: React.ComponentType<any>;
  fields?: Field[];
  fieldWrapper?: string;
  sameAsFields?: string[];
  errorMustContain?: string;
}

interface Page {
  route: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: React.ComponentType<any>;
  cards?: Card[];
  accordions?: { title: string; cards: Card[] }[];
}

// ----------------- Page Templates -----------------
const contactFields: Field[] = [
  { key: CONTACT_FIELDS.email },
  { key: CONTACT_FIELDS.fax }
];

const companyPageTemplate: Page = {
  route: PAGE_ROUTES.company,
  Component: CompanyPage,
  cards: [
    {
      key: CARD_CATEGORIES.company,
      Component: CompanyCard,
      fields: [
        { key: COMPANY_FIELDS.legalName },
        { key: COMPANY_FIELDS.tradeDbaName, required: true }
      ]
    },
    {
      key: CARD_CATEGORIES.soldTo,
      Component: SoldToAddressCard,
      fields: [
        { key: SOLD_TO_ADDRESS_FIELDS.address, required: true },
        { key: SOLD_TO_ADDRESS_FIELDS.taxNumber1, required: true },
        { key: SOLD_TO_ADDRESS_FIELDS.taxNumber2 },
        { key: SOLD_TO_ADDRESS_FIELDS.taxNumber3 },
        { key: SOLD_TO_ADDRESS_FIELDS.taxNumber4 },
        { key: SOLD_TO_ADDRESS_FIELDS.email },
        { key: SOLD_TO_ADDRESS_FIELDS.telephone1 },
        { key: SOLD_TO_ADDRESS_FIELDS.telephone2 }
      ],
      errorMustContain: 'address'
    },
    {
      key: CARD_CATEGORIES.deliveryInstructions,
      Component: DeliveryInstructionsCard,
      fields: [
        { key: DELIVERY_INSTRUCTIONS_FIELDS.shippingInstructions },
        { key: DELIVERY_INSTRUCTIONS_FIELDS.externalInvoiceText },
        { key: DELIVERY_INSTRUCTIONS_FIELDS.loadingInstructions },
        { key: DELIVERY_INSTRUCTIONS_FIELDS.unloadingInstructions },
        { key: DELIVERY_INSTRUCTIONS_FIELDS.packingInstructions },
        { key: DELIVERY_INSTRUCTIONS_FIELDS.billOfLadingText }
      ],
      fieldWrapper: CARD_CATEGORIES.shipTo
    },
    {
      key: CARD_CATEGORIES.coa,
      Component: CertOfAnalysisContactCard,
      fields: contactFields,
      fieldWrapper: CARD_CATEGORIES.shipTo
    },
    {
      key: CARD_CATEGORIES.packingList,
      Component: PackingListContactCard,
      fields: contactFields,
      fieldWrapper: CARD_CATEGORIES.shipTo,
      sameAsFields: [CONTACT_SAME_AS_FIELDS.sameAsCoa]
    },
    {
      key: CARD_CATEGORIES.invoiceDelivery,
      Component: InvoiceDeliveryContactCard,
      fields: [...contactFields],
      fieldWrapper: CARD_CATEGORIES.shipTo + '[0]'
    },
    {
      key: CARD_CATEGORIES.orderConfirmation,
      Component: OrderConfirmationContactCard,
      fields: contactFields,
      fieldWrapper: CARD_CATEGORIES.shipTo,
      sameAsFields: [CONTACT_SAME_AS_FIELDS.sameAsCoa, CONTACT_SAME_AS_FIELDS.sameAsPackingList]
    },
    {
      key: CARD_CATEGORIES.additionalAttachmentCard,
      Component: AdditionalAttachmentCard,
      fields: [{ key: ATTACHMENT_FIELDS.additionalAttachment }]
    },
    {
      key: CARD_CATEGORIES.privacyPolicy,
      Component: PrivacyPolicyCard
    }
  ]
};

const reviewPageTemplate: Page = {
  route: PAGE_ROUTES.review,
  Component: ReviewPage,
  accordions: [
    {
      title: 'tabTitles.company',
      cards: companyPageTemplate.cards!
    }
  ]
};

// ----------------- Export Pages -----------------
const pages: Page[] = [companyPageTemplate, reviewPageTemplate];

export default pages;